// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__xvhjO","pagination":"styles_pagination__RJh1k"};